import { APP_CONSTANTS } from '../constants/AppConstants';

function clarityScript(id) {
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      /* istanbul ignore next */
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', id);
}

export default class Clarity {
  static clarityInit() {
    clarityScript(APP_CONSTANTS.CLARITY_ID);
  }

  static clarityHasStarted = () => {
    //@ts-ignore
    return typeof window.clarity === 'function';
  };

  static setClarityTag = (key: string, value: string | string[]) => {
    //@ts-ignore
    clarity('set', key, value);
  };
}